import fetch from 'cross-fetch';
import React from 'react';

import {
  ApolloClient,
  ApolloProvider,
  ApolloLink,
  createHttpLink,
  InMemoryCache,
} from '@apollo/client';
import { removeTypenameFromVariables } from '@apollo/client/link/remove-typename';

import typeDefs from './LocalResolver/typeDefs';
import config from '../config';
import resolvers from './LocalResolver/resolvers';
import fragmentTypes from './schema/fragmentTypes.json';
import { BlockUnsupportedBrowsers } from '$/sections/PublishedWebinar/ViewWebinar/BlockUnsupportedBrowsers';
import merge from 'lodash/merge';
require('$/utils/yup-email');

const removeTypenameLink = removeTypenameFromVariables();

const httpLink = createHttpLink({
  uri: config.GRAPHQL_SERVER_URL,
  fetch,
  fetchOptions: {
    credentials: 'include',
  },
});

const client = new ApolloClient({
  link: ApolloLink.from([removeTypenameLink, httpLink]),
  cache: new InMemoryCache({
    possibleTypes: fragmentTypes.possibleTypes,
    typePolicies: {
      InteractionDetails: {
        merge: true,
      },
      SetSettings: {
        merge: (existing, incoming) => {
          return merge({}, existing, incoming);
        },
      },
    },
  }),
  resolvers,
  typeDefs,
});

const BackendConnection: React.FC<{ children?: React.ReactNode }> = ({ children }) => {
  return (
    <ApolloProvider client={client}>
      <BlockUnsupportedBrowsers />
      {children}
    </ApolloProvider>
  );
};

export default BackendConnection;
